/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_PAYMENT_IN_DETAILS = `${url}/LOAD_PAYMENT_IN_DETAILS`;
export const LOAD_PAYMENT_IN_DETAILS_SUCCESS = `${url}/LOAD_PAYMENT_IN_DETAILS_SUCCESS`;
export const LOAD_PAYMENT_IN_DETAILS_ERROR = `${url}/LOAD_PAYMENT_IN_DETAILS_ERROR`;
export const LOAD_PAYMENT_IN_DETAILS_REPORT = `${url}/LOAD_PAYMENT_IN_DETAILS_REPORT`;
export const LOAD_PAYMENT_IN_DETAILS_REPORT_SUCCESS = `${url}/LOAD_PAYMENT_IN_DETAILS_REPORT_SUCCESS`;
export const LOAD_PAYMENT_IN_DETAILS_REPORT_ERROR = `${url}/LOAD_PAYMENT_IN_DETAILS_REPORT_ERROR`;

export const LOAD_PARTY_ACCOUNT_LIST = `${url}/LOAD_PARTY_ACCOUNT_LIST`;
export const LOAD_PARTY_ACCOUNT_LIST_SUCCESS = `${url}/LOAD_PARTY_ACCOUNT_LIST_SUCCESS`;
export const LOAD_PARTY_ACCOUNT_LIST_ERROR = `${url}/LOAD_PARTY_ACCOUNT_LIST_ERROR`;
export const LOAD_PAYMENT_SETTLED_LIST = `${url}/LOAD_PAYMENT_SETTLED_LIST`;
export const LOAD_PAYMENT_SETTLED_LIST_SUCCESS = `${url}/LOAD_PAYMENT_SETTLED_LIST_SUCCESS`;
export const LOAD_PAYMENT_SETTLED_LIST_ERROR = `${url}/LOAD_PAYMENT_SETTLED_LIST_ERROR`;

export const CREATE_PAYMENT_IN_DETAILS = `${url}/CREATE_PAYMENT_IN_DETAILS`;
export const CREATE_PAYMENT_IN_DETAILS_SUCCESS = `${url}/CREATE_PAYMENT_IN_DETAILS_SUCCESS`;
export const CREATE_PAYMENT_IN_DETAILS_ERROR = `${url}/CREATE_PAYMENT_IN_DETAILS_ERROR`;

//category

export const UPDATE_PAYMENT_IN_DETAILS = `${url}/UPDATE_PAYMENT_IN_DETAILS`;
export const UPDATE_PAYMENT_IN_DETAILS_SUCCESS = `${url}/UPDATE_PAYMENT_IN_DETAILS_SUCCESS`;
export const UPDATE_PAYMENT_IN_DETAILS_ERROR = `${url}/UPDATE_PAYMENT_IN_DETAILS_ERROR`;

export const DELETE_PAYMENT_IN_DETAILS = `${url}/DELETE_PAYMENT_IN_DETAILS`;
export const DELETE_PAYMENT_IN_DETAILS_SUCCESS = `${url}/DELETE_PAYMENT_IN_DETAILS_SUCCESS`;
export const DELETE_PAYMENT_IN_DETAILS_ERROR = `${url}/DELETE_PAYMENT_IN_DETAILS_ERROR`;

export const LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA = `${url}/LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA`;
export const LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_SUCCESS`;
export const LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_ERROR = `${url}/LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

const constants = {
  LOAD_PAYMENT_IN_DETAILS,
  LOAD_PAYMENT_IN_DETAILS_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_ERROR,
  LOAD_PAYMENT_IN_DETAILS_REPORT,
  LOAD_PAYMENT_IN_DETAILS_REPORT_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_REPORT_ERROR,

  LOAD_PAYMENT_SETTLED_LIST,
  LOAD_PAYMENT_SETTLED_LIST_SUCCESS,
  LOAD_PAYMENT_SETTLED_LIST_ERROR,
  LOAD_PARTY_ACCOUNT_LIST,
  LOAD_PARTY_ACCOUNT_LIST_SUCCESS,
  LOAD_PARTY_ACCOUNT_LIST_ERROR,

  CREATE_PAYMENT_IN_DETAILS,
  CREATE_PAYMENT_IN_DETAILS_SUCCESS,
  CREATE_PAYMENT_IN_DETAILS_ERROR,

  UPDATE_PAYMENT_IN_DETAILS,
  UPDATE_PAYMENT_IN_DETAILS_SUCCESS,
  UPDATE_PAYMENT_IN_DETAILS_ERROR,

  DELETE_PAYMENT_IN_DETAILS,
  DELETE_PAYMENT_IN_DETAILS_SUCCESS,
  DELETE_PAYMENT_IN_DETAILS_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA,
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_SUCCESS,
  LOAD_PAYMENT_IN_DETAILS_RECORDS_META_DATA_ERROR,
};

export default constants;
